import { connect } from 'react-redux';

// Actions
import { fetchPages } from 'actions/website/PageActions';

// Selectors
import { getWeddingTheme } from 'selectors/website/websiteSelectors';

import VirtualEventPreviewLive from './VirtualEventPreviewLive';

const mapStateToProps = state => ({
  theme: getWeddingTheme(state),
});

const mapDispatchToProps = dispatch => ({
  getPages: () => dispatch(fetchPages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEventPreviewLive);



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/ZoomEdit/components/VirtualEventPreviewLive/index.js